var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntroAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 30.5,
    height: 30.5,
    rx: 15.25,
    fill: "#9CA3AF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 30.5,
    height: 30.5,
    rx: 15.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3996 15.9996C22.3996 17.697 21.7253 19.3249 20.5251 20.5251C19.3249 21.7253 17.697 22.3996 15.9996 22.3996C14.3022 22.3996 12.6744 21.7253 11.4741 20.5251C10.2739 19.3249 9.59961 17.697 9.59961 15.9996C9.59961 14.3022 10.2739 12.6744 11.4741 11.4741C12.6744 10.2739 14.3022 9.59961 15.9996 9.59961C17.697 9.59961 19.3249 10.2739 20.5251 11.4741C21.7253 12.6744 22.3996 14.3022 22.3996 15.9996V15.9996ZM17.5996 13.5996C17.5996 14.024 17.431 14.4309 17.131 14.731C16.8309 15.031 16.424 15.1996 15.9996 15.1996C15.5753 15.1996 15.1683 15.031 14.8682 14.731C14.5682 14.4309 14.3996 14.024 14.3996 13.5996C14.3996 13.1753 14.5682 12.7683 14.8682 12.4682C15.1683 12.1682 15.5753 11.9996 15.9996 11.9996C16.424 11.9996 16.8309 12.1682 17.131 12.4682C17.431 12.7683 17.5996 13.1753 17.5996 13.5996V13.5996ZM15.9996 16.7996C15.2337 16.7995 14.4838 17.0192 13.8391 17.4327C13.1945 17.8463 12.682 18.4362 12.3628 19.1324C12.813 19.6561 13.371 20.0762 13.9988 20.364C14.6265 20.6518 15.3091 20.8004 15.9996 20.7996C16.6902 20.8004 17.3727 20.6518 18.0005 20.364C18.6282 20.0762 19.1863 19.6561 19.6364 19.1324C19.3172 18.4362 18.8048 17.8463 18.1601 17.4327C17.5154 17.0192 16.7655 16.7995 15.9996 16.7996V16.7996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroAvatar);
export default __webpack_public_path__ + "static/media/intro-avatar.1354acdd42923ee3d02683726ac82bcb.svg";
export { ForwardRef as ReactComponent };